<template>
    <div class="container">
        <template v-if="shifts">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Shifts</h1>
                <router-link to="addShifts" class="btn btn-primary float-right">Add Shifts</router-link>
            </div>
            <table id="shiftsTable" class="table" style="width:100%">
                <thead>
                    <tr>
                        <th>Shift Name</th>
                        <th>Required Weekly Hours</th>
                        <th>Overtime</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-if="shifts == false">
            Sorry this page is not accessable!
        </template>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                shifts:null,
                shift_crud:null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('shifts|shift_crud').then(result => {
                this.shifts = result.shifts;
                this.shift_crud = result.crud_shifts;
            }).then(result => {
                if(this.shifts == true){
                    this.getShiftsData();
                }
            });
        },
        methods: {
            getShiftsData: function(){
                var that = this;
                $('#shiftsTable').DataTable({
                    processing: true,
                    serverSide: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "api/getShifts",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'weekly_hours'},
                        {data: 'overtime'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editShift/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" >Edit</a>';
                        }, visible: that.shift_crud},
                    ],
                    "order": [[ 0, "desc" ]],
                });
            }
        },
        created() {
        }
    }
</script>
